import React, { useState } from "react";
import { Box, Label, Input, theme, ErrorExclamationView } from "Application";
import { observer } from "mobx-react-lite";
import { ErrorContainer, ScoreContainer, FormFieldContainer } from "../Shared/Styles/FormField.styles";
import { StudentSessionSubTargetViewModel } from "./StudentSessionSubTargetViewModel";
import { FormField } from "Views/Shared/Views/SessionReport/SessionReportSessionPlan.styles";
import classNames from "classnames";

//currently this view only adds a session report sub target
export const StudentSessionSubTargetView: React.FC<{ viewModel: StudentSessionSubTargetViewModel }> = observer(({ viewModel }) => {
    const { isMobile } = viewModel;

    return (
        <FormFieldContainer className={classNames({ isMobile: isMobile })}>
            <FormField>
                <Box mb="10px">
                    <Label fontStyle="label">Score*</Label>
                </Box>
                <ErrorContainer>
                    <ErrorExclamationView haveError={viewModel.showScoreError} validationMessage={() => viewModel.getError("score")} />
                </ErrorContainer>
                <ScoreContainer>
                    <Input
                        noHeader
                        maxLength={2}
                        isRequired={false}
                        value={() => viewModel.score}
                        command={viewModel.updateScoreCommand}
                        onBlur={() => viewModel.onScoreBlurCommand.execute()}
                        showClearText={false}
                    />
                    <Box position="absolute" top="50%" right="12px" style={{ transform: "translateY(-51%)" }}>
                        <Label fontStyle="field">/10</Label>
                    </Box>
                </ScoreContainer>
            </FormField>
        </FormFieldContainer>
    );
});
